// extracted by mini-css-extract-plugin
module.exports = {"diagramContainer":"DiagramContainer_diagramContainer__1DsAE","canvasWidget":"DiagramContainer_canvasWidget__1OVmx"};